// import node module libraries
import React, { useState } from "react";
import { Outlet } from "react-router-dom";

// import sub components
import NavbarVertical from "./NavbarVertical";
import HeaderDefault from "./HeaderDefault";
import Footer from "components/footer/footer";

const DashboardIndex = (props) => {
    const { children, className, overflowHidden } = props;
    const [showMenu, setShowMenu] = useState(true);
    const ToggleMenu = () => {
        return setShowMenu(!showMenu);
    };
    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <div className="header">
                <HeaderDefault
                    data={{
                        showMenu: showMenu,
                        SidebarToggleMenu: ToggleMenu,
                    }}
                />
            </div>
            <div
                className={`container-fluid ${className ? className : "p-4 px-0"
                    } mt-6 overflow-hidden`}
                style={{ flex: '1 0 auto' }}
            >
                {children}
                <Outlet />
            </div>
            <div style={{ flexShrink: 0 }}>
                <Footer />
            </div>
        </div>
    );
};
export default DashboardIndex;
